import React, { useState } from "react";
import { movefolderTypesMatch } from "utils/optionData/utils";
import SC from "./style";
import { Radio } from "@mui/material";

const Folder = (props) => {
  const { folder, setSelectedFolderId, selectedFolderId } = props;

  const folderType = movefolderTypesMatch.find(
    (item) => item.id === folder.folderType
  );
  const folderIcon = folderType ? folderType.icon : "📂";

  const handleChange = (event) => {
    // alert(folder.id);
    setSelectedFolderId(folder.id);
  };

  return (
    <SC.FolderContainer>
      <SC.FolderHeader>
        <SC.FolderName>
          {/* Render radio button if folderType is 2 */}
          {folderType && folderType.id === 2 && (
            <>
              {/* <input
                type="radio"
                name="folder"
                value={folder.id}
                onChange={handleChange}
                style={{ color: "orange" }}
              /> */}
              <Radio
                checked={selectedFolderId === folder.id}
                onChange={handleChange}
                value={folder.id}
                name="folder-radio"
                inputProps={{ "aria-label": folder.name }}
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 16,
                  },
                  "&.Mui-checked": {
                    color: "#EC810B",
                  },
                }}
              />
            </>
          )}

          <SC.FolderIcon>{folderIcon}</SC.FolderIcon>
          <SC.ValueSpanP>{folder.name}</SC.ValueSpanP>
        </SC.FolderName>
      </SC.FolderHeader>

      <div className="folder-children">
        {folder.children.map((child) => (
          <Folder
            key={child.id}
            folder={child}
            setSelectedFolderId={setSelectedFolderId}
            selectedFolderId={selectedFolderId}
          />
        ))}
      </div>
    </SC.FolderContainer>
  );
};

export default Folder;
